import { Trans } from "@lingui/react/macro";
import { ArrowClockwiseIcon, HouseIcon, WarningIcon } from "@phosphor-icons/react";
import { Link, type NotFoundRouteProps } from "@tanstack/react-router";

import { Button, buttonVariants } from "@/components/ui/button";

import { Alert, AlertDescription, AlertTitle } from "../ui/alert";

export function NotFoundScreen(_props: NotFoundRouteProps) {
  return (
    <main
      className="mx-auto flex min-h-svh w-full max-w-lg flex-col items-center justify-center gap-4 px-4 py-10"
      data-testid="global-safe-not-found-boundary"
    >
      <Alert className="w-full">
        <WarningIcon />
        <AlertTitle>
          <Trans>Not found</Trans>
        </AlertTitle>
        <AlertDescription>
          <Trans>Something went wrong. Please try again.</Trans>
        </AlertDescription>
      </Alert>

      <div className="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Link to="/" className={buttonVariants({ variant: "outline" })}>
          <HouseIcon />
          <Trans>Home</Trans>
        </Link>
        <Button type="button" onClick={() => window.location.reload()}>
          <ArrowClockwiseIcon />
          <Trans>Retry</Trans>
        </Button>
      </div>
    </main>
  );
}
